import * as React from 'react';
import { Card } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getNextStep, getOverview } from '../../../../actions/claimHistoryActionsV2'
import { navigateTo } from '../../../../actions/navigationActions';
import { CLAIMSV2_FEEDBACK } from '../../../../routes/routes';
import '../../ClaimsHistoryV2/ClaimsHistory.css'
import ClaimsTile from '../ClaimHistoryComponents/ClaimsTile';

class ClaimComplete extends React.Component<any, any> {

    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.getClaimStatusClass = this.getClaimStatusClass.bind(this);
        this.handleBackClick = this.handleBackClick.bind(this);
    }

    async handleClick() {
        this.props.handleFanclubFeedback();
    }

    getClaimStatusClass(claimStatus) {

        let cssClass = '';

        switch (claimStatus) {
            case 'Approved': cssClass = 'Approved'
                break;

            case 'Closed': cssClass = 'Cancelled';
                break;

            case 'Pending': cssClass = 'Pending';
                break;

            case 'Unknown': cssClass = 'hidden';
                break;

            default: cssClass = 'hidden';
        }
        return cssClass;
    }

    async handleBackClick() {
        this.props.handleClaimsBackClick();
    }

    render() {
        let carHireStep = this.props.claimSubmit.claimProgress.claimSteps.filter(x => x.claimStepDescription.toLowerCase() === "car hire")
        let showCarHire = carHireStep[0]?.claimCarHireStep.carHireSteps.filter(x => x.indCurrentStep === 1).length > 0
        let currCarHireStep = carHireStep[0]?.claimCarHireStep.carHireSteps.filter(x => x.indCurrentStep === 1)
        return (
            <>
                <div id="ClaimComplete"> </div>
                <button className="claims-back-button" onClick={this.handleBackClick}> <img className="claims-back-button-img" src="/my-policy/Images/Claims/ClaimsV2/Dropdown-arrow-left.png" alt="" title="" />Back</button>
                <Card>
                    {this.props.claimSubmit.selectedClaim.claimStatus.toLowerCase() !== "approved" &&
                        <Card className="content-box-padding-20px-with-box-shadow pb-0">
                            <div className="row noma">
                                <div className="col-12 nopa">
                                <ClaimsTile />
                                </div>
                            </div>
                        </Card>
                    }
                    {this.props.claimSubmit.selectedClaim.claimStatus.toLowerCase() === "approved" &&
                        <>
                        <Card.Header className="card-round border-0">
                            <h3 className="mt-15px"><img src="./Images/Claims/Number-progress.png" alt="complete" className="pr-15px" />Claim completed</h3>
                            <p>Yay, your claim is done-zo</p>
                            <hr className="mb-0" />
                        </Card.Header>
                        
                        <Card.Body>
                            <strong>Thanks for choosing the king</strong>
                            <p className="mt-15px ">Please take a sec to give us your feedback below</p>
                            <button className="give-feedback-button btn-solid-green mt-10px mb-20px" onClick={this.handleClick}>Give feedback</button>
                        </Card.Body>
                        </>
                    }
                    {showCarHire && this.props.claimSubmit.selectedClaim.claimStatus.toLowerCase() === "repudiated" && this.props.claimSubmit.selectedClaimProgressStep.repudiationReason === "Claim closed" && 
                        <Card.Body>
                            <div className="dot float-left Cancelled mt-0px mr-10px"></div> <p className="cancelled-text">Status: Claim closed</p>
                        <p className="float-left mt-0px mr-10px">Thanks for letting us know that you don’t want to proceed with this claim. We’ve cancelled it on our side. We've noted this as an incident on your profile, so that we have a complete history for you.</p>
                        {currCarHireStep[0].cancelStatus?.toLowerCase() === "cancelled" || currCarHireStep[0].cancelStatus?.toLowerCase() === "repudiated" &&
                            <p className="float-left mt-0px mr-10px"> We’ve also cancelled your rental car and let the rental company know. Please return the rental car ASAP to avoid any additional costs for your account? Thanks.</p>
                            }
                        </Card.Body>
                    }
                    {!showCarHire && this.props.claimSubmit.selectedClaim.claimStatus.toLowerCase() === "repudiated" && this.props.claimSubmit.selectedClaimProgressStep.repudiationReason === "Claim closed" &&
                        <Card.Body>
                            <div className="dot float-left Cancelled mt-0px mr-10px"></div> <p className="cancelled-text">Status: Claim closed</p>
                        <p className="float-left mt-0px mr-10px">Thanks for letting us know that you don’t want to proceed with this claim. We’ve cancelled it on our side. We've noted this as an incident on your profile, so that we have a complete history for you.</p>
                            
                        </Card.Body>
                    }
                    { showCarHire && this.props.claimSubmit.selectedClaim.claimStatus.toLowerCase() === "repudiated" && this.props.claimSubmit.selectedClaimProgressStep.repudiationReason === "Claim not approved" &&
                        <Card.Body>
                            <div className="dot float-left Cancelled mt-0px mr-10px"></div> <p className="cancelled-text">Status: Claim not approved</p>
                        <p className="float-left mt-0px mr-10px">Unfortunately, this claim isn’t valid. We’ve sent you a detailed explanation via email, so please check your inbox?</p>
                        { currCarHireStep[0].cancelStatus?.toLowerCase() === "cancelled" || currCarHireStep[0].cancelStatus?.toLowerCase() === "repudiated" &&
                            <p className="float-left mt-0px mr-10px"> We’ve also cancelled your rental car and let the rental company know. Please return the rental car ASAP to avoid any additional costs for your account? Thanks.</p>
                            }
                        </Card.Body>
                    }
                    {!showCarHire && this.props.claimSubmit.selectedClaim.claimStatus.toLowerCase() === "repudiated" && this.props.claimSubmit.selectedClaimProgressStep.repudiationReason === "Claim not approved" &&
                        <Card.Body>
                            <div className="dot float-left Cancelled mt-0px mr-10px"></div> <p className="cancelled-text">Status: Claim not approved</p>
                        <p className="float-left mt-0px mr-10px">Unfortunately, this claim isn’t valid. We’ve sent you a detailed explanation via email, so please check your inbox?</p>
                        </Card.Body>
                    }
                </Card>
               
            </>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        firebase: state.firebase,
        claimSubmit: state.claimSubmit,
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleGetNextStep: () => dispatch(getNextStep()),
        handleClaimsBackClick: () => dispatch(getOverview()),
        handleFanclubFeedback: () => dispatch(navigateTo(CLAIMSV2_FEEDBACK))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ClaimComplete);
